<Modal
  title="Delete offer"
  actionTitle="Delete"
  isDanger
  {isLoading}
  on:close={() => ($uiState.activeModal = undefined)}
  on:action={() => apply()}>
  <p class="block">Are you sure you want to delete '{item.data.name}'?</p>
  <p class="block">You cannot undo this action.</p>
  {#if errorMessage}
    <div class="notification is-danger is-light">{errorMessage}</div>
  {/if}
</Modal>

<script lang="ts">
  export let item: Offer_v2_Doc;
  export let navPath : string

  import { logging } from '../../../../../lib/logging';
  import { goto } from '@sveltech/routify';
  import { uiState } from "../../../../../lib/uiState";
  import Modal from "../../../../_components/Modal.svelte";

  let errorMessage : string;
  let isLoading = false;

  async function apply() {
    isLoading = true;

    let firebase = window.firebase;

    await firebase
      .functions()
      .httpsCallable('api-offer-deleteoffer')({ id: item.id } as DeleteOfferParams)
      .catch((err) => {
        logging.report(err.toString());
        errorMessage = err;
      })
      .finally(() => (isLoading = false));

    // TODO report error

    isLoading = false;

    $uiState.activeModal = undefined;

    $goto(navPath);
  }
</script>
